module.exports = __webpack_public_path__ + "static/media/1021306.3d179d54.png";